import React from "react";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";

import MoreButton from "components/CustomButtons/MoreButton";

const BrowseByTaxonomy = dynamic(() =>
  import("components/Feedblocks/BrowseByTaxonomy").then(
    (mod) => mod.BrowseByTaxonomy
  )
);

export default function SectionBrowseByProducts(props) {
  const {
    categories,
    categorySlug,
    loading,
    showAllProductsButton,
    noTaxonomy,
    centerContent,
    makeTitleH1,
  } = props;

  const { t } = useTranslation();
  //const loading = true;
  // Dummy object to populate loading skeleton:

  const dummyNodes = [1];
  const dummyChars = [...Array(12).keys()];
  const dummyCategories = {
    nodes: [
      {
        characteristics: {
          uri: "#",
          edges: dummyNodes.map((node, index) => {
            return {
              id: `n-${index}`,
              terms: {
                edges: dummyChars.map((char, chindex) => {
                  return { id: `c-${index}-${chindex}` };
                }),
              },
            };
          }),
        },
      },
    ],
  };

  const categoriesToUse = categories || dummyCategories;
  return (
    <>
      {categorySlug || loading ? (
        categoriesToUse &&
        categoriesToUse.nodes.map((category) => {
          const sport =
            category.sports?.edges && category.sports.edges.length === 1
              ? category.sports.edges[0].node.name.toLowerCase() + " "
              : "";
          return (
            category.characteristics && (
              <React.Fragment key={`${category.slug}-top`}>
                <MoreButton
                  show={showAllProductsButton}
                  uri={category.characteristics.uri}
                  text={t("feeds:showAllForCategory", {
                    title: category.characteristics.title,
                  })}
                  loading={loading}
                  centerContent={centerContent}
                />
                {category.characteristics.edges.map((item) => {
                  const taxonomy =
                    item.characteristic?.node.labelSingle.toLowerCase();
                  const titleProps = {
                    taxonomy,
                    taxonomies: item.characteristic?.node.label.toLowerCase(),
                    category: category.categoryDetails?.singleName,
                    categories: category.name?.toLowerCase(),
                    sport,
                  };
                  return (
                    <React.Fragment key={`browse-by-${category}-${taxonomy}`}>
                      <BrowseByTaxonomy
                        makeTitleH1={
                          makeTitleH1 &&
                          category.characteristics.edges.length === 1
                        }
                        edgesOrNodes="edges"
                        item={item}
                        centerContent={centerContent}
                        category={category.name}
                        loading={loading}
                        showDivider={showAllProductsButton}
                        alwaysShowMoreButton={noTaxonomy}
                        feedTitle={
                          sport
                            ? t(
                                "feeds:browseProductsByCategoryAndSport",
                                titleProps
                              )
                            : t("feeds:browseProductsByCategory", titleProps)
                        }
                        moreButtonText={
                          sport
                            ? t("feeds:seeAllBySportAndCategory", titleProps)
                            : t("feeds:seeAllByCategory", titleProps)
                        }
                        showTotals
                      />
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            )
          );
        })
      ) : (
        <React.Fragment key={`browse-by-category`}>
          <BrowseByTaxonomy
            item={{ terms: categories }}
            edgesOrNodes="nodes"
            loading={loading}
            feedTitle={t("feeds:browseRootProducts")}
            showTitle
            centerContent
            alwaysShowMoreButton={noTaxonomy}
          />
        </React.Fragment>
      )}
    </>
  );
}
